import barba from '@barba/core';
import { gsap, ScrollTrigger, CustomEase } from "gsap/all";
gsap.registerPlugin(CustomEase);
// import Cookies from 'js-cookie';

import Header from "./header";
import NavMobile from "./nav-mobile";
import Reveal from "./reveal";
import Embed from "./embed";
import SmvAccordion from "./accordion";

export default class BarbaJs {

  constructor() {
    const html = document.querySelector('html');
    const body = document.querySelector('body');
    const navigationLinks = document.querySelectorAll('.navigation--main-link');
    const navigationTrigger = document.querySelectorAll('.header--navigation-trigger');
    var scrollPosY = [0];
    // Check if user prefers reduced motion
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    barba.init({
      timeout: 7500,

      // debug: true,
      // cacheIgnore: true,
      // prefetchIgnore: true,

      // requestError: (trigger, action, url, response) => {
      //   console.log({
      //     trigger: trigger,
      //     action: action,
      //     url: url,
      //     response: response,
      //   })
      // },

      prevent: ({ el }) => el.classList && (el.classList.contains('prevent-barba') || el.classList.contains('active')),

      transitions: [
        {
          name: 'default-transition',

          once(data) {
            // scroll to anchor
            if (window.location.hash) {
              const target = document.querySelector(window.location.hash);
              if (target) {
                setTimeout(() => {
                  target.scrollIntoView({
                    behavior: 'smooth',
                  });
                }, 250);
              }
            }

            setTimeout(() => {
              new Header();
              new NavMobile();
              new Embed('.js--embed');
              // accordions collapse their content on init — create the
              // reveal triggers afterwards so they measure final positions
              new SmvAccordion('.js--accordion');
              new Reveal('.js--reveal');
            }, 1);


            return gsap.to(body, {
              opacity: 1,
              duration: prefersReducedMotion ? 0 : 0.75,
              delay: 0.75,
              onStart: () => {
              }
            });
          },

          beforeLeave(data) {
            if (data.trigger !== "back") {
              scrollPosY.push(window.scrollY);
            }

            return gsap.to(data.current.container, {
              opacity: 0,
              duration: prefersReducedMotion ? 0 : 0.5,
              delay: 0,
            });

          },

          afterLeave(data) {
            // update body classes
            body.classList.toggle('is-home', data.next.namespace === 'home');
            body.classList.toggle('not-home', data.next.namespace !== 'home');
            data.current.container.remove();
          },

          beforeEnter(data) {
            navigationLinks.forEach(navigationLink => {
              navigationLink.classList.toggle('active', navigationLink.dataset.slug === data.next.namespace || navigationLink.dataset.slug === data.next.container.dataset.slug);
            });

            // remove focus from active element
            if (document.activeElement) {
              document.activeElement.blur();
            }

            data.next.container.style.opacity = 0;
          },


          enter(data) {
            // reinit JS
            setTimeout(() => {
              // new Header();
              new NavMobile();
              new Embed('.js--embed');
              // accordions collapse their content on init — create the
              // reveal triggers afterwards so they measure final positions
              new SmvAccordion('.js--accordion');
              new Reveal('.js--reveal');
            }, 1);

            if (data.trigger == 'back') {
              window.scrollTo(0, 0);
              ScrollTrigger.refresh();
              let scrollPosYTarget = scrollPosY.pop();
              setTimeout(() => {
                window.scrollTo(0, scrollPosYTarget);
                ScrollTrigger.refresh();
              }, 10);
            } else {
              window.scrollTo(0, 0);
              ScrollTrigger.refresh();
            }
          },

          afterEnter(data) {
            return gsap.to(data.next.container, {
              opacity: 1,
              duration: prefersReducedMotion ? 0 : 0.5,
              delay: 1,
              onComplete: () => {
                // scroll to anchor
                if (window.location.hash) {
                  const target = document.querySelector(window.location.hash);
                  if (target) {
                    setTimeout(() => {
                      target.scrollIntoView({
                        behavior: 'smooth',
                      });
                    }, 250);
                  }
                }
              }
            });
          }

        },
      ],

    });
  }

}
